import {
  WhiteInstantSearchBuilder,
  NoResults,
  Pagination,
} from '@white-nl/instantsearch-components';

import { Hit } from '../components/news/results/Hit';
import Loading from '../components/news/results/Loading';

const settings = document.getElementById('news-overview')?.dataset || null;
const whiteInstantSearchNews = new WhiteInstantSearchBuilder();
if (settings) {
  whiteInstantSearchNews
    .withSearchkit(
      settings.indexName || '',
      settings.publicUrl || '',
      settings.jwt || '',
      settings.refreshUrl || '',
    )
    .withWhiteInstantSearchRouting({
      baseUrl: settings.baseUrl,
      addTrailingSlashesToUrls: settings.trailingSlashes === '1',
    })
    .setHitsPerPage(9)
    .addAdditionalData({ hitsPerPage: 9 })
    .addHitComponent([
      {
        settings: {
          loading: {
            translations: {
              loading: settings.section === 'News' ? Craft.t('news', 'Loading news...') : Craft.t('press', 'Loading press...'),
            },
          },
          noResults: {
            translations: {
              noResults: settings.section === 'News' ? Craft.t('news', 'Sorry, we can\'t find any news!') : Craft.t('press', 'Sorry, we can\'t find any press news!'),
              refinements: settings.section === 'News' ? Craft.t('news', 'Try to reset your applied filters.') : Craft.t('press', 'Try to reset your applied filters.'),
              query: settings.section === 'News' ? Craft.t('news', 'Please come back later.') : Craft.t('press', 'Please come back later.'),
            },
          },
        },
        component: Hit,
        loadingComponent: Loading,
        noResultsComponent: NoResults,
      },
    ])
    .addPaginationComponent([
      {
        settings: {
          showFirst: false,
          showLast: false,
          classNames: {
            list: 'pagination',
            item: 'page-item',
            previousPageItem: 'previous',
            selectedItem: 'active',
            disabledItem: 'disabled',
            nextPageItem: 'next',
            link: 'page-link',
          },
          translations: {
            previousPageItemText: Craft.t('pagination', 'Previous'),
            previousPageItemAriaLabel: Craft.t('pagination', 'Go to previous page'),
            nextPageItemText: Craft.t('pagination', 'Next'),
            nextPageItemAriaLabel: Craft.t('pagination', 'Go to next page'),
          },
        },
        component: Pagination,
      },
    ])
    .setScrolling({
      includeAttributes: ['page'],
      element: '#news-overview',
    })
    .where(`siteId:${settings.siteId}`)
    .andWhere(`section:${settings.section}`)
    .build()
    .show();
}
